import React, { useContext } from 'react';
import { userRolesToLabelMap } from '@bb/users';

import { LayoutContext, TeamContext } from 'contexts';
import { Avatar, Space, TableProps } from 'components';

import { StyledTable, UserStatusTag } from '../../../components';

const compareFirstName = (a = '', b = '') => a.localeCompare(b);

const TeamMembersTable: React.FC = () => {
  const { transition } = useContext(LayoutContext);
  const { targetTeamState, setSelectedUsers } = useContext(TeamContext);

  const columns: TableProps['columns'] = [
    {
      width: 250,
      title: 'Name',
      key: 'name',
      dataIndex: 'name',
      render: (name: string, user: any) => (
        <Space align="center" size="middle">
          <Avatar user={user.avatar} />
          {`${user.firstName} ${user.lastName}`}
        </Space>
      ),
    },
    {
      width: 350,
      title: 'Email',
      key: 'email',
      dataIndex: 'email',
    },
    {
      width: 100,
      title: 'Status',
      key: 'status',
      dataIndex: '',
      align: 'center',
      render: ({ disabled, isUnverified }) => (
        <UserStatusTag disabled={disabled} isUnverified={isUnverified} />
      ),
    },
    {
      width: 150,
      title: 'Role',
      key: 'role',
      dataIndex: 'role',
    },
    {}, // for empty column
  ];

  const dataSource = targetTeamState.users
    .sort((aUser, bUser) => compareFirstName(aUser.firstName, bUser.firstName))
    .map(
      ({
        id,
        firstName,
        lastName,
        email,
        role,
        avatarFilestackId,
        disabled,
        isUnverified,
      }) => ({
        id,
        key: id,
        firstName,
        lastName,
        avatar: { firstName, lastName, avatarFilestackId },
        email,
        role: userRolesToLabelMap[role],
        disabled,
        isUnverified,
      }),
    );

  return (
    <StyledTable
      style={{
        transition: `all ${transition}s`,
      }}
      pagination={false}
      dataSource={dataSource}
      columns={columns}
      rowSelection={{
        type: 'checkbox',
        onChange: (selectedRowKeys, selectedRows) => {
          setSelectedUsers(selectedRowKeys as string[]);
        },
        getCheckboxProps: record => ({
          id: record.id,
        }),
      }}
    />
  );
};

export default TeamMembersTable;
